export default "﻿<div>\n    <div data-dojo-attach-point=\"formContainer\" class=\"w3-section w3-content padding border round\"></div>\n</div>"